import axios from "axios";
import {
  API_URL,
  dispatchLoading,
  dispatchError,
  catchHandler,
  elseHandler,
  dispatchToast,
} from "../../helpers/utils";
import { message } from "antd";

const USER_URL = `${API_URL}/admin`;
const limit = 15;

export const ListUser =
  (page, is_active, start_date, end_date, time_zone, setIsLoading) =>
  async (dispatch) => {
    dispatchLoading(dispatch, "user", true);
    setIsLoading(true);
    axios
      .get(`${USER_URL}/users`, {
        params: { page, is_active, limit, start_date, end_date, time_zone },
      })
      .then((result) => {
        if (result?.data?.success) {
          setIsLoading(false);
          dispatch({
            type: "USER_LIST_SUCCESS",
            payload: {
              list: result?.data?.data?.data,
              count: result?.data?.data?.count,
            },
          });
          dispatchError(dispatch, "user", undefined);
        } else elseHandler(dispatch, "user", result?.data);
        dispatchLoading(dispatch, "user", false);
      })
      .catch(catchHandler(dispatch, "user"));
  };

export const GetUserById = (id) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .get(`${USER_URL}/users`, { params: { id } })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "FETCH_USER_DETAILS",
          payload: result?.data?.data?.data.find((ele, i) => ele?._id === id),
        });
        dispatchError(dispatch, "user", undefined);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const DeleteUserAPI = (id, setIsConfirm) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .delete(`${USER_URL}/user`, { data: { id } })
    .then((result) => {
      if (result?.data?.success) {
        // dispatch(PermanentDeleteUser(id));
        dispatchToast(dispatch, "success", result?.data?.message);
        setIsConfirm(false);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const DeleteUserPermanentAPI =
  (id, setIsConfirm, params, isLoading) => async (dispatch) => {
    dispatchLoading(dispatch, "user", true);
    axios
      .delete(`${USER_URL}/user/permanent`, { data: { id } })
      .then((result) => {
        if (result?.data?.success) {
          // dispatch(PermanentDeleteUser(id));
          dispatchToast(dispatch, "success", result?.data?.message);
          // dispatch(ListUserWithOnlyParams(params, isLoading));
          setIsConfirm(false);
        } else elseHandler(dispatch, "user", result?.data);
        dispatchLoading(dispatch, "user", false);
      })
      .catch(catchHandler(dispatch, "user"));
  };

export const RestoreUserAPI = (id, setIsConfirm) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .put(`${USER_URL}/user/restore`, { id })
    .then((result) => {
      if (result?.data?.success) {
        // dispatch(PermanentDeleteUser(id));
        dispatchToast(dispatch, "success", result?.data?.message);
        setIsConfirm(false);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const PermanentDeleteUser = (id) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .delete(`${USER_URL}/user/permanent`, { data: { id } })
    .then((result) => {
      if (result?.data?.success) {
        dispatch(ListUser2());
        dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "user", undefined);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const SearchUser = (search) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .get(`${USER_URL}/users`, { params: { search, limit: 15 } })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "USER_SEARCH_SUCCESS",
          payload: {
            list: result?.data?.data?.data,
            count: result?.data?.data?.count,
          },
        });
        dispatchError(dispatch, "user", undefined);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const toggleUser = (data, fetchData) => async (dispatch) => {
  dispatchLoading(dispatch, "user", true);
  axios
    .put(`${USER_URL}/user/status`, data)
    .then((result) => {
      if (result?.data?.success) {
        // dispatch({ type: "USER_TOGGLE_SUCCESS", payload: result?.data });
        // dispatch(ListUser3(params));
        fetchData();
        // dispatchToast(dispatch, "success", result?.data?.message);
        dispatchError(dispatch, "user", undefined);
      } else elseHandler(dispatch, "user", result?.data);
      dispatchLoading(dispatch, "user", false);
    })
    .catch(catchHandler(dispatch, "user"));
};

export const ListUser2 =
  (page, is_active, start_date, end_date, time_zone) => async (dispatch) => {
    dispatchLoading(dispatch, "user", true);
    axios
      .get(`${USER_URL}/users`, {
        params: { page, is_active, limit, start_date, end_date, time_zone },
      })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "USER_LIST_SUCCESS",
            payload: {
              list: result?.data?.data?.data,
              count: result?.data?.data?.count - 1,
            },
          });
          dispatchError(dispatch, "user", undefined);
        } else elseHandler(dispatch, "user", result?.data);
        dispatchLoading(dispatch, "user", false);
      })
      .catch(catchHandler(dispatch, "user"));
  };

export const ListUser3 =
  ({ page, is_active, start_date, end_date, time_zone }) =>
  async (dispatch) => {
    dispatchLoading(dispatch, "user", true);
    axios
      .get(`${USER_URL}/users`, {
        params: { page, is_active, limit, start_date, end_date, time_zone },
      })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "USER_LIST_SUCCESS",
            payload: {
              list: result?.data?.data?.data,
              count: result?.data?.data?.count - 1,
            },
          });
          dispatchError(dispatch, "user", undefined);
        } else elseHandler(dispatch, "user", result?.data);
        dispatchLoading(dispatch, "user", false);
      })
      .catch(catchHandler(dispatch, "user"));
  };

export const ListUserWithOnlyParams =
  (params, setIsLoading) => async (dispatch) => {
    dispatchLoading(dispatch, "user", true);

    setIsLoading(true);

    axios
      // .get(`${USER_URL}/users`, { params: { page, is_active, limit, start_date, end_date, time_zone } })
      .get(`${USER_URL}/users`, { params: params })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "USER_LIST_SUCCESS",
            payload: {
              list: result?.data?.data?.data,
              count: result?.data?.data?.count,
            },
          });
          dispatchError(dispatch, "user", undefined);
        } else elseHandler(dispatch, "user", result?.data);
        dispatchLoading(dispatch, "user", false);

        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        catchHandler(dispatch, "user");
      });
  };

export const EditUserTrialDurationAPI =
  (data, cancelHandler, editParams, setIsLoading) => async (dispatch) => {
    console.log("editParams", editParams);
    setIsLoading(true);
    dispatchLoading(dispatch, "quote", true);
    axios
      .put(`${USER_URL}/user/free-trial/extend`, data)
      .then((result) => {
        if (result?.data?.success) {
          cancelHandler && cancelHandler();

          dispatch(ListUserWithOnlyParams(editParams, setIsLoading));
        } else elseHandler(dispatch, "quote", result?.data);
        dispatchLoading(dispatch, "quote", false);
        cancelHandler && cancelHandler();
      })
      .catch(() => {
        cancelHandler && cancelHandler();
        catchHandler(dispatch, "quote");
      });
  };

export const ToggleChallengeForUser =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.put(
        `${API_URL}/auth/challenge-feature-allow`,
        data
      );

      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        }
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };
